import { render, staticRenderFns } from "./story-card.vue?vue&type=template&id=642e96ca&"
import script from "./story-card.vue?vue&type=script&lang=js&"
export * from "./story-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports